/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_Sec_IntroductionInputs */

const en_funnel_demo_sec_introduction = /** @type {(inputs: Funnel_Demo_Sec_IntroductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduction`)
};

const es_funnel_demo_sec_introduction = /** @type {(inputs: Funnel_Demo_Sec_IntroductionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introducción`)
};

/**
* | output |
* | --- |
* | "Introduction" |
*
* @param {Funnel_Demo_Sec_IntroductionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_sec_introduction = /** @type {((inputs?: Funnel_Demo_Sec_IntroductionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_Sec_IntroductionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_sec_introduction(inputs)
	return en_funnel_demo_sec_introduction(inputs)
});